import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CreditCard, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import api from "../lib/api";

export const ProtectedRoute = ({ children, allowPending = false }) => {
  const [status, setStatus] = useState(null);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.user) {
      setUser(location.state.user);
      setStatus(true);
      return;
    }

    const checkAuth = async () => {
      try {
        const res = await api.get("/auth/me");
        if (res.data && res.data.user_id) {
          setUser(res.data);
          localStorage.setItem("vita_user", JSON.stringify(res.data));
          setStatus(true);
        } else {
          setStatus(false);
        }
      } catch (err) {
        console.error('Auth check failed:', err.message || err);
        setStatus(false);
      }
    };
    checkAuth();
  }, [location.state]);

  if (status === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-10 w-10 border-3 border-[#0B6E4F] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-500 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (status === false) {
    return <Navigate to="/auth" replace />;
  }

  // Block pending_trial users — redirect to pricing to add payment
  if (!allowPending && user?.subscription_tier === "pending_trial") {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#FDFCFB] to-[#E8F5E9] flex items-center justify-center px-4" data-testid="trial-gate">
        <div className="bg-white border border-slate-100 rounded-2xl p-8 max-w-md w-full shadow-xl text-center">
          <div className="w-16 h-16 bg-[#F2F9F6] rounded-full flex items-center justify-center mx-auto mb-5">
            <CreditCard className="h-8 w-8 text-[#0B6E4F]" />
          </div>
          <h2 className="font-['Outfit'] text-2xl font-bold text-[#0F172A] mb-2">Start Your Free Trial</h2>
          <p className="text-sm text-slate-500 mb-6 leading-relaxed">
            Add a payment method to unlock your <strong>7-day free trial</strong> with full access to all features. You won't be charged during the trial period.
          </p>
          <Link to="/pricing">
            <Button data-testid="trial-gate-btn" className="w-full h-12 bg-[#0B6E4F] hover:bg-[#095A40] text-white rounded-full font-semibold shadow-lg">
              Choose a Plan <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <p className="text-xs text-slate-400 mt-4">Cancel anytime. No charges during trial.</p>
        </div>
      </div>
    );
  }

  return children;
};
